
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19.018","height":"23.507"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Maps-Navigation / Pins Style One / style-one-pin"}},[_c('g',{attrs:{"fill":"none","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","data-name":"Group 98"}},[_c('path',{attrs:{"data-name":"Shape 386","d":"M18.518 9.52a9 9 0 10-13.492 7.79c1.688.974 2.143 2.049 4.057 5.443a.5.5 0 00.871 0c1.934-3.431 2.372-4.471 4.056-5.443a8.985 8.985 0 004.508-7.79z"}}),_c('path',{attrs:{"data-name":"Oval 59","d":"M9.518 14.52a5 5 0 10-5-5 5 5 0 005 5z"}})])])])
          )
        }
      }
    